"use strict";
var import_fs = require("fs");
var import_os = require("os");
var import_path = require("path");
var import_vitest = require("vitest");
var import_routeIndex = require("./routeIndex");
var testDir;
function writeRoute(relativePath) {
  testDir || (testDir = (0, import_fs.mkdtempSync)((0, import_path.join)((0, import_os.tmpdir)(), "one-route-index-")));
  var filePath = (0, import_path.join)(testDir, "app", relativePath);
  (0, import_fs.mkdirSync)((0, import_path.dirname)(filePath), {
    recursive: true
  });
  (0, import_fs.writeFileSync)(filePath, "export default function Route() { return null }");
  return filePath;
}
(0, import_vitest.afterEach)(function() {
  if (testDir) {
    (0, import_fs.rmSync)(testDir, {
      recursive: true,
      force: true
    });
    testDir = void 0;
  }
});
(0, import_vitest.describe)(import_routeIndex.createRouteIndex, function() {
  (0, import_vitest.it)("scans and filters the route tree once", function() {
    writeRoute("index.tsx");
    writeRoute("nested/page.ts");
    writeRoute("nested/page.test.tsx");
    writeRoute("routes.d.ts");
    var routeIndex = (0, import_routeIndex.createRouteIndex)({
      routerRoot: (0, import_path.join)(testDir, "app"),
      ignoredRouteFiles: [
        "**/*.test.*"
      ]
    });
    (0, import_vitest.expect)(routeIndex.getPaths()).toEqual([
      "./index.tsx",
      "./nested/page.ts"
    ]);
  });
  (0, import_vitest.it)("updates route membership from watcher events", function() {
    writeRoute("index.tsx");
    var routeIndex = (0, import_routeIndex.createRouteIndex)({
      routerRoot: (0, import_path.join)(testDir, "app"),
      ignoredRouteFiles: [
        "**/*.test.*"
      ]
    });
    var addedRoute = writeRoute("nested/new.tsx");
    var ignoredRoute = writeRoute("nested/new.test.tsx");
    (0, import_vitest.expect)(routeIndex.update("add", addedRoute)).toBe(true);
    (0, import_vitest.expect)(routeIndex.update("add", ignoredRoute)).toBe(false);
    (0, import_vitest.expect)(routeIndex.getPaths()).toEqual([
      "./index.tsx",
      "./nested/new.tsx"
    ]);
    (0, import_vitest.expect)(routeIndex.update("unlink", addedRoute)).toBe(true);
    (0, import_vitest.expect)(routeIndex.getPaths()).toEqual([
      "./index.tsx"
    ]);
  });
});
//# sourceMappingURL=routeIndex.test.js.map
